<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_titleBack enjoy">
      <div class="attach_subtitle">
        <h1>enJoy 멤버십</h1>
        <p>본 멤버십은 2024년 5월 31일부로 종료되었습니다</p>
      </div>
    </div>
    <!--rew19_titleBack-->
<!--    <div class="rew19_fixed_inside">-->
<!--      <ul class="rew19_rainback_membership">-->
<!--        <li class="inRainback">-->

<!--          <div class="distinguishingLine">            -->
<!--            <div class="info_emphasis">-->
<!--              <strong>{{getMemberNmKr()}}</strong> 고객님은-->
<!--              <em>{{$nvl(viewData.memberShip.gradeName, '-')}}</em> 회원입니다.-->
<!--            </div>-->

<!--            <div v-if="viewData.memberShip.isUseAro != 'Y'" class="info_roundBackground">-->
<!--              정기구매 신청 시 <span class="point_green">{{$nvl(viewData.memberShip.nextGradeName, '-')}}</span>-->
<!--               등급으로 승급합니다.-->
<!--            </div>-->
<!--            <div v-else-if="viewData.memberShip.gradeCode == '4'" class="info_roundBackground">-->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.vipGiftMonth, '-')}}</span>에 -->
<!--              <span class="point_green">파운틴Ⅴ 스페셜패키지</span>를 받으실 예정입니다.              -->
<!--            </div>-->
<!--            <div v-else-if="viewData.memberShip.gradeCode == '3'" class="info_roundBackground">              -->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.dispDueDate, '-')}}</span>에 -->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.nextGradeName, '-')}}</span> 등급으로-->
<!--               승격되어 <span class="point_green">파운틴Ⅴ 스페셜패키지</span>를 받으실 예정입니다.              -->
<!--            </div>-->
<!--            <div v-else-if="viewData.memberShip.gradeCode == '2'" class="info_roundBackground">              -->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.dispDueDate, '-')}}</span>에 -->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.nextGradeName, '-')}}</span> 등급으로-->
<!--               승격되어 <span class="point_green">파운틴Ⅳ 스페셜패키지</span>를 받으실 예정입니다.-->
<!--            </div>-->
<!--            <div v-else-if="viewData.memberShip.gradeCode == '1'" class="info_roundBackground">              -->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.dispDueDate, '-')}}</span>에 -->
<!--              <span class="point_green">{{$nvl(viewData.memberShip.nextGradeName, '-')}}</span> 등급으로-->
<!--               승격되어 <span class="point_green">기념일쿠폰</span>을 받으실 예정입니다.-->
<!--            </div>            -->
<!--            <div v-if="!(viewData.memberShip.gradeCode == '0' || viewData.memberShip.gradeCode == '1')"-->
<!--              class="inSetup">-->
<!--              <span class="title">나의 기념일 :</span>-->
<!--              <span class="date">{{viewData.anniversary.dspAnniversary}}</span>-->
<!--              <a @click="openChangeServicelifeDialog" class="setup"><span>설정</span></a>-->
<!--            </div>-->
<!--          </div>-->
<!--          -->
<!--        </li>-->
<!--        <li class="inCircleform">-->
<!--          <a -->
<!--            @click="onClickMoveMyCoupon"-->
<!--            :class="{active : viewData.memberShip.couponCount > 0}"-->
<!--            class="schematized_data">-->
<!--            <span -->
<!--              :class="{yellowGreen : viewData.memberShip.couponCount > 0, gray : viewData.memberShip.couponCount <= 0}"-->
<!--              class="circle ">-->
<!--              <span class="txtInfo">-->
<!--                <em>{{$nvl(viewData.memberShip.couponCount, 0)}}</em>개-->
<!--              </span>-->
<!--            </span>-->
<!--            <span class="titleInfo">멤버십쿠폰</span>-->
<!--          </a>-->
<!--          <a @click="onClickMoveVipList"-->
<!--            :class="{active : '3' == viewData.memberShip.gradeCode || '4' == viewData.memberShip.gradeCode}" -->
<!--            class="schematized_data">-->
<!--            <span -->
<!--              :class="{-->
<!--                blue : '3' == viewData.memberShip.gradeCode || '4' == viewData.memberShip.gradeCode}"-->
<!--              class="circle">-->
<!--              <span class="txtInfo">파운틴 라운지</span>-->
<!--            </span>-->
<!--            <span class="titleInfo">-->
<!--              <template v-if="!('3' == viewData.memberShip.gradeCode || '4' == viewData.memberShip.gradeCode)">-->
<!--                파운틴Ⅳ 승급예정일 : <span class="date">{{$nvl(viewData.memberShip.vipDueDate, '-')}}</span>-->
<!--              </template>-->
<!--              <template v-else-if="('3' == viewData.memberShip.gradeCode || '4' == viewData.memberShip.gradeCode)">-->
<!--                <br/>-->
<!--                &lt;!&ndash;{{$nvl(viewData.memberShip.gradeName, '')}} 승급일 : <span class="date">{{$nvl(viewData.memberShip.vipDueDate, '-')}}</span>&ndash;&gt;-->
<!--              </template>-->
<!--            </span>-->
<!--          </a>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <!--rew19_fixed_inside-->
<!--    <div class="infographics_wrap">-->
<!--      <ul class="infographics_list">-->
<!--        <li :class="{-->
<!--            grade : '0' == viewData.memberShip.gradeCode,-->
<!--            normal : '0' != viewData.memberShip.gradeCode,-->
<!--          }">-->
<!--          <em v-if="'0' == viewData.memberShip.gradeCode"-->
<!--            class="times">{{viewData.memberShip.aroBuyCount}}회</em>-->
<!--          <div class="infographics"></div>-->
<!--          <span class="infographics_txt">파운틴Ⅰ<br/>기본등급</span>-->
<!--        </li>-->
<!--        <li :class="{-->
<!--            grade : '1' == viewData.memberShip.gradeCode,-->
<!--            normal : '1' != viewData.memberShip.gradeCode,-->
<!--          }">-->
<!--          <em v-if="'1' == viewData.memberShip.gradeCode"-->
<!--            class="times">{{viewData.memberShip.aroBuyCount}}회</em>-->
<!--          <div class="infographics"></div>-->
<!--          <span class="infographics_txt">파운틴Ⅱ<br/>정기구매 1개월 차 이상</span>-->
<!--        </li>-->
<!--        <li :class="{-->
<!--            grade : '2' == viewData.memberShip.gradeCode,-->
<!--            normal : '2' != viewData.memberShip.gradeCode,-->
<!--          }">-->
<!--          <em v-if="'2' == viewData.memberShip.gradeCode"-->
<!--            class="times">{{viewData.memberShip.aroBuyCount}}회</em>-->
<!--          <div class="infographics"></div>-->
<!--          <span class="infographics_txt">파운틴Ⅲ<br/>정기구매 7개월 차 이상</span>-->
<!--        </li>-->
<!--        <li :class="{-->
<!--            grade : '3' == viewData.memberShip.gradeCode,-->
<!--            normal : '3' != viewData.memberShip.gradeCode,-->
<!--          }">-->
<!--          <em v-if="'3' == viewData.memberShip.gradeCode"-->
<!--            class="times">{{viewData.memberShip.aroBuyCount}}회</em>-->
<!--          <div class="infographics"></div>-->
<!--          <span class="infographics_txt">파운틴Ⅳ<br/>정기구매 13개월 차 이상</span>-->
<!--        </li>-->
<!--        <li :class="{-->
<!--            grade : '4' == viewData.memberShip.gradeCode,-->
<!--            normal : '4' != viewData.memberShip.gradeCode,-->
<!--          }">          -->
<!--          <div class="infographics"></div>-->
<!--          <span class="infographics_txt">파운틴Ⅴ<br/>정기구매 25개월 차 이상</span>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
<!--    &lt;!&ndash;infographics_wrap&ndash;&gt;-->
<!--    <div class="rew19_bottomLine">-->
<!--      <ul class="rew19_fixed_inside rew19_small_dotList">-->
<!--        <li>정기구매 시작 일 : {{$nvl(viewData.memberShip.startDate, '-')}}</li>-->
<!--        <li>enJoy 멤버십 등급은 보유하신 정기구매 중 가장 오래된 건을 기준(NTC, 에이지락 미 리워드 제외)으로 산정되며, 익월 1일에 반영됩니다.</li>-->
<!--      </ul>-->
<!--    </div>-->
<!--    <div class="rew19_grayback_incenter">-->
<!--      <div class="pc"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner01_enjoy_pc.jpg"/></div>-->
<!--      <div class="mb"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner01_enjoy_mb.jpg"/></div>-->
<!--    </div>-->
<!--    <div class="rew19_back_enjoy">-->
<!--      <div class="rew19_maxwidth">-->
<!--        <h3 class="rew19_titleBenefit">멤버십 등급 혜택 안내</h3>-->
<!--        <ul class="rew19_infoBenefit">-->
<!--          <li :class="{active : '0' == viewData.memberShip.gradeCode}" class="level step01">-->
<!--            <h4>파운틴Ⅰ-->
<!--              <em><span class="marking"></span></em>-->
<!--            </h4>-->
<!--            <div class="step01">-->
<!--              <span class="caption">뉴스킨 코리아의 <em class="nextLine">모든 회원</em></span>-->
<!--            </div>-->
<!--            <div class="step02">-->
<!--              <span class="caption">신규회원 할인쿠폰</span>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li :class="{active : '1' == viewData.memberShip.gradeCode}" class="level step02">-->
<!--            <h4>파운틴Ⅱ-->
<!--              <em>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--              </em>-->
<!--            </h4>-->
<!--            <div class="step01">-->
<!--              <span class="caption">정기구매 <em class="nextLine">1~6개월 차 회원</em></span>-->
<!--            </div>-->
<!--            <div class="step02">-->
<!--              <span class="caption">정기구매 <span class="wordbreak">5~15% 할인</span></span>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li :class="{active : '2' == viewData.memberShip.gradeCode}" class="level step03">-->
<!--            <h4>파운틴Ⅲ-->
<!--              <em>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--              </em>-->
<!--            </h4>-->
<!--            <div class="step01">-->
<!--              <span class="caption">정기구매 <em class="nextLine">7~12개월 차 회원</em></span>-->
<!--            </div>-->
<!--            <div class="step02">-->
<!--              <span class="caption">정기구매 <span class="wordbreak">10~15% 할인</span></span>-->
<!--            </div>-->
<!--            <div class="step03">-->
<!--              <span class="caption">기념일 쿠폰(연 1회) -->
<!--                <span class="additional"> 1만원 할인 쿠폰-->
<!--                  <em class="nextLine">(10만원 이상 구매 시)</em>-->
<!--                </span>-->
<!--              </span>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li :class="{active : '3' == viewData.memberShip.gradeCode}" class="level step04">-->
<!--            <h4>파운틴Ⅳ-->
<!--              <em>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--              </em>-->
<!--            </h4>-->
<!--            <div class="step01">-->
<!--              <span class="caption">정기구매 <em class="nextLine">13~24개월 차 회원</em></span>-->
<!--            </div>-->
<!--            <div class="step02">-->
<!--              <span class="caption">정기구매 <span class="wordbreak">10~15% 할인</span></span>-->
<!--            </div>-->
<!--            <div class="step03">-->
<!--              <span class="caption">기념일 쿠폰(연 1회)-->
<!--                <span class="additional"> 1만원 할인 쿠폰-->
<!--                  <em class="nextLine">(10만원 이상 구매 시)</em>-->
<!--                </span>-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="step04">-->
<!--              <span class="caption">파운틴Ⅳ 스페셜 패키지-->
<!--                <ul class="normal">-->
<!--                  <li>1년 감사 기프트(연 1회)</li>-->
<!--                </ul>-->
<!--                <ul class="normal">-->
<!--                  <li>e쿠폰(분기 1회)</li>-->
<!--                </ul>-->
<!--                <ul class="additional">-->
<!--                  <li>무료 배송 쿠폰</li>-->
<!--                  <li>5천원 할인 쿠폰(5만원 이상 구매)</li>-->
<!--                </ul>-->
<!--                <ul class="normal">-->
<!--                  <li>뉴스킨몰 파운틴 라운지 이용</li>-->
<!--                </ul>-->
<!--              </span>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li :class="{active : '4' == viewData.memberShip.gradeCode}" class="level step05">-->
<!--            <h4>파운틴Ⅴ-->
<!--              <em>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--                <span class="marking"></span>-->
<!--              </em>-->
<!--            </h4>-->
<!--            <div class="step01">-->
<!--              <span class="caption">정기구매 <em class="nextLine">25개월 차 이상 회원</em></span>-->
<!--            </div>-->
<!--            <div class="step02">-->
<!--              <span class="caption">정기구매 <span class="wordbreak">10~15% 할인</span></span>-->
<!--            </div>-->
<!--            <div class="step03">-->
<!--              <span class="caption">기념일 쿠폰(연 1회) -->
<!--                <span class="additional"> 1만원 할인 쿠폰-->
<!--                  <em class="nextLine">(10만원 이상 구매 시)</em>-->
<!--                </span>-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="step04">-->
<!--              <span class="caption">파운틴Ⅴ 스페셜 패키지-->
<!--                <ul class="normal">-->
<!--                  <li>1년 감사 기프트(연 1회)</li>-->
<!--                </ul>-->
<!--                <ul class="normal">-->
<!--                  <li>e쿠폰(분기 1회)</li>-->
<!--                </ul>-->
<!--                <ul class="additional">-->
<!--                  <li>무료배송 쿠폰</li>-->
<!--                  <li>5천원 할인 쿠폰(5만원 이상 구매)</li>-->
<!--                  <li>1만원 할인 쿠폰(10만원 이상 구매)</li>-->
<!--                </ul>-->
<!--                <ul class="normal">-->
<!--                  <li>뉴스킨몰 파운틴 라운지 이용</li>-->
<!--                </ul>-->
<!--              </span>-->
<!--            </div>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <ul class="rew19_small_dotList">-->
<!--          <li>정기구매 5-15% 할인은 정기구매 장바구니 할인 혜택으로 할인율은 장바구니 별 유지 기간에 따라 상이할 수 있으며, 15% 할인은 약정 정기구매에 한하여 적용됩니다.</li>-->
<!--          <li>기념일 쿠폰은 파운틴III 이상 회원을 대상으로, 본인이 지정한 기념일(기본값은 생일)의 월 1일에 발급되는 쿠폰입니다.</li>-->
<!--          <li>1년 감사 기프트는 승급월 1일 정기구매 첫 결제 장바구니에 포함되어 자동 발송되며, e쿠폰은 승급월로부터 3개월 마다 자동 발행됩니다.</li>-->
<!--          <li>파운틴V를 지속 유지하시면 매년 정기구매 시작 월에 파운틴V 스페셜 패키지가 제공됩니다.</li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
    <!--//rew19_back_enjoy-->

<!--    <div class="rew19_grayback_incenter">-->
<!--      <div class="pc"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner02_enjoy_pc.jpg"/></div>-->
<!--      <div class="mb"><img src="https://resource2018.nuskinkorea.co.kr/images/aro/banner02_enjoy_mb.jpg"/></div>-->
<!--    </div>-->

<!--    <change-servicelife-dialog-->
<!--      ref="changeServicelifeDialog"-->
<!--      :show="changeServicelifeDialogShow"-->
<!--      @close='onCloseChangeServicelifeDialog'></change-servicelife-dialog>-->

<!--    <member-ship-barcode-dialog-->
<!--      ref="memberShipBarcodeDialog"-->
<!--      :show="memberShipBarcodeDialogShow"-->
<!--      @close='onCloseMemberBarcodeDialog'></member-ship-barcode-dialog>-->
  </div>
</template>
<script>
import AroBase from "@/components/base/AroBase";
import ChangeServicelifeDialog from '@/components/popup/ChangeServicelifeDialog';
import MemberShipBarcodeDialog from '@/components/popup/MemberShipBarcodeDialog';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

import DF from 'dateformat';

export default {
  name: "memberShip",
  extends: AroBase,
  components: {
    ChangeServicelifeDialog, MemberShipBarcodeDialog
  },
  computed: {
    isNuskinChannel: function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    },
    isMeCommerceChannel : function(){
      return this.$aroChannel == Const.ARO_CHANNEL_ME_COMMERCE;
    }
  },
  props: {
  },

  data: () => ({
    //View Data
    viewData : {
      memberShip :{
        // aroBuyCount: 11
        // buyPeriod: "11",
        // couponCount: "0",
        // dueDate: "2019-10-01",
        // gradeCode: "1",
        // gradeName: "파운틴Ⅱ",
        // isUseAro: "Y",
        // message: "조회성공",
        // nextGradeCode: "2",
        // nextGradeName: "파운틴Ⅲ",
        // startDate: "2019-04-30",
        // status: "0000",
        // vipDueDate: "2020-04-01",

        couponCount: 0,
      },

      anniversary : {
        // anniversaryInfo: "08-13",
        // message: "조회성공",
        // status: "0000",
      }
    },

    //기념일 변경 dialog
    changeServicelifeDialogShow : false,
    changeServicelifeDialog : {

    },

    //바코드 dialog
    memberShipBarcodeDialogShow : false,
    memberShipBarcodeDialog : {

    },
  }),
  created() {
    let _this = this;
  },
  mounted() {
    let _this = this;

    _this.initUI();

    _this.loadData();
  },
  watch:{
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI : function(){

    },

    /**
     * API Request
     */
    //멤버쉽 정보 가져오기
    apiGetMemberShips : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/memberships`, {
        params: {}
      });
    },

    //쿠폰 카운트 가져오기
    apiGetCouponCount : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/couponCount`, {
        params: {}
      });
    },

    //기념일 조회
    apiGetAnniversary : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/anniversary`, {
        params: {}
      });
    },

    //기념일 등록
    apiPostAnniversary : function(anniversary){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/post_anniversary`, {
        params: {
          anniversary : anniversary
        }
      });
    },

    //기념일 수정
    apiPutAnniversary : function(anniversary){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_anniversary`, {
        params: {
          anniversary : anniversary
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadData : function(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetMemberShips().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          //success

          _this.viewData = {
            ..._this.viewData,
            memberShip : {...res.data}
          };
          //TestCode
          //_this.viewData.memberShip.gradeCode = '4';

          //쿠폰은 Nuksin 에서 가져오도록 변경
          _this.viewData.memberShip.couponCount = 0;
          //쿠폰수량
          // if(_this.viewData.memberShip.couponCount){
          //   _this.viewData.memberShip.couponCount = parseInt(""+_this.viewData.memberShip.couponCount,10);
          // }
          //TestCode
          //_this.viewData.couponCount = 1;

          //VIP 승급 예정일
          if(_this.viewData.memberShip.vipDueDate){
            _this.viewData.memberShip.vipDueDate = _this.viewData.memberShip.vipDueDate.replace(/-/g,'.');
            let vipMonth = 0;
            vipMonth = parseInt(_this.viewData.memberShip.vipDueDate.substring(5, 7), 10);
          }

          //정기구매 시작일
          if(_this.viewData.memberShip.startDate){
            let startDate = _this.viewData.memberShip.startDate;
            startDate = startDate.replace(/-/g,'.');

            let month = 0;
            month = parseInt(startDate.substring(5, 7), 10);

            let today = new Date();
            let giftYear = today.getFullYear();
            let currentMonth = today.getMonth()+1;
            if( currentMonth > month){
              giftYear = giftYear +1;
            }
            _this.viewData.memberShip.vipGiftMonth = `${giftYear}년 ${month}월`;
          }

          //다음 승급 예정일
          if(_this.viewData.memberShip.dueDate){
            _this.viewData.memberShip.dispDueDate = _this.viewData.memberShip.dueDate.substring(0,8);
            _this.viewData.memberShip.dispDueDate = _this.viewData.memberShip.dispDueDate.replace(/-/,'년 ');
            _this.viewData.memberShip.dispDueDate = _this.viewData.memberShip.dispDueDate.replace(/-/,'월');

            _this.viewData.memberShip.dueDate = _this.viewData.memberShip.dueDate.replace(/-/g,'.');
          }

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        //기념일 조회
        return _this.apiGetAnniversary();
      }).then(res=>{
        if (res.status === 200 && res.data.status === "0000") {
          //success

          _this.viewData = {
            ..._this.viewData,
            anniversary : {...res.data}
          };

          //기념일 처리
          if(_this.viewData.anniversary.anniversaryInfo){
            let das = _this.viewData.anniversary.anniversaryInfo.split("-");
            let month = parseInt(das[0], 10);
            let date = parseInt(das[1], 10);
            let str = "";
            try{
              str = `${month}월 ${date}일`;
            }catch(e){
              str = _this.viewData.anniversary.anniversaryInfo;
            }

            _this.viewData.anniversary.dspAnniversary = str;
            _this.viewData.anniversary.strMonth = month > 9 ? ""+month : "0"+month;
            _this.viewData.anniversary.strDate = date > 9 ? ""+date : "0"+date;
          }

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        //쿠폰 카운트 가져오기
        return _this.apiGetCouponCount();
      }).then(res=>{

        _this.viewData.memberShip.couponCount = 0;
        if (res.status === 200 && res.data.status === "0000") {
          //success
          _this.viewData.memberShip.couponCount = res.data.couponCount;

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //나의 쿠폰으로 이동
    onClickMoveMyCoupon(){
      let _this = this;

      if(_this.viewData.couponCount <= 0){
        return;
      }

      if(_this.isNuskinChannel){
        //Nuskin 경우
        let targetUrl = '/app/my/ReadMyMileage';
        window.location.href = targetUrl;
        return;
      }

      //기타 사이트
      const options = {cancelLabel: '취소', okLabel:'확인'};
      let msg = `뉴스킨 몰 '쿠폰/마일리지'로 이동 하시겠습니까?`;
      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          let targetUrl = 'https://www.nuskinkorea.co.kr/app/my/ReadMyMileage';
          window.location.href = targetUrl;
        }
      });
    },

    //파운틴 라운지 이동
    onClickMoveVipList(){
      let _this = this;

      if(!('3' == _this.viewData.memberShip.gradeCode || '4' == _this.viewData.memberShip.gradeCode)){
        return;
      }

      if(_this.isNuskinChannel){
        //Nuskin 경우
        let targetUrl = '/app/ro/aroShop/vipList';
        window.location.href = targetUrl;
        return;
      }

      //기타 사이트
      const options = {cancelLabel: '취소', okLabel:'확인'};
      let msg = `뉴스킨 몰 '쿠폰/마일리지'로 이동 하시겠습니까?`;
      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          let targetUrl = 'https://www.nuskinkorea.co.kr/app/ro/aroShop/vipList';
          window.location.href = targetUrl;
        }
      });
    },

    //기념일 변경 dialog 열기
    openChangeServicelifeDialog(){
      let _this = this;

      _this.changeServicelifeDialog = {
        ..._this.changeServicelifeDialog,
        ..._this.viewData.anniversary
      }
      _this.$refs.changeServicelifeDialog.initData(_this.changeServicelifeDialog);
      _this.changeServicelifeDialogShow = true;
    },

    //기념일 변경 처리
    onCloseChangeServicelifeDialog(isOk, data){
      let _this = this;

      if(!isOk){
        _this.changeServicelifeDialogShow = false;

        //Do nothing.
        return;
      }

      _this.changeServicelifeDialogShow = false;

      Promise.resolve().then(()=>{
        _this.$showLoading();
        if(_this.viewData.anniversary.dspAnniversary){
          //수정
          return _this.apiPutAnniversary(data.anniversaryInfo);
        }else{
          //등록
          return _this.apiPostAnniversary(data.anniversaryInfo);
        }
      }).then(res=>{
        if (res.status === 200 && res.data.status === "0000") {
          //success
          _this.$dialogs.alert("기념일을 변경하였습니다.")
          .then(res => {});

          return _this.apiGetAnniversary();
        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
          return null;
        }
      }).then(res=>{
        if(!res){
          return;
        }

        if (res.status === 200 && res.data.status === "0000") {
          //success

          _this.viewData = {
            ..._this.viewData,
            anniversary : {...res.data}
          };

          //기념일 처리
          if(_this.viewData.anniversary.anniversaryInfo){
            let das = _this.viewData.anniversary.anniversaryInfo.split("-");
            let month = parseInt(das[0], 10);
            let date = parseInt(das[1], 10);
            let str = "";
            try{
              str = `${month}월 ${date}일`;
            }catch(e){
              str = _this.viewData.anniversary.anniversaryInfo;
            }

            _this.viewData.anniversary.dspAnniversary = str;
            _this.viewData.anniversary.strMonth = month > 9 ? ""+month : "0"+month;
            _this.viewData.anniversary.strDate = date > 9 ? ""+date : "0"+date;
          }

        }else{
          //Fail
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //바코드 popup
    openMemberBarcodeDialog(){
      let _this = this;

      _this.memberShipBarcodeDialog = {
        ..._this.memberShipBarcodeDialog
      };
      _this.$refs.memberShipBarcodeDialog.initData(_this.memberShipBarcodeDialog);
      _this.memberShipBarcodeDialogShow = true;
    },

    //바코드 닫기
    onCloseMemberBarcodeDialog(isOk, data){

      let _this = this;
      _this.memberShipBarcodeDialogShow = false;
    }
  }
};
</script>
<style>
a.setup, a.barcode, a.active.schematized_data{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/njoy/memberShip.vue